import { DatePipe, NgFor } from '@angular/common';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Event } from '@tanzspass/shared';
import { ConvService } from '../../services/conv.service';
import { TvScreenService } from '../../services/tv-screen.service';
import { TvSlideService } from '../../services/tv-slide.service';

@Component({
  selector: 'ts-infosystem-events',
  templateUrl: './infosystem-events.component.html',
  styleUrls: ['./infosystem-events.component.css'],
  imports: [NgFor, DatePipe],
})
export class InfosystemEventsComponent implements OnInit {
  @Input() schoolId: number;
  /**
   * Max events to show. Defaults to the shared cap, but layouts with more
   * vertical room (e.g. non-overview mode) can raise it to fill the panel.
   */
  @Input() maxCount = TvSlideService.newsCount;
  events: Event[] = [];

  constructor(
    private tvScreenSrv: TvScreenService,
    private convSrv: ConvService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    // Subscribe in ngOnInit, not the constructor: this component is created only
    // after the first payload exists (gated on school?.id), so payload$ — a
    // BehaviorSubject — replays its current value *synchronously* on subscribe.
    // In the constructor that replay runs before Angular binds @Inputs, so it
    // would slice with the default maxCount; ngOnInit runs after inputs bind.
    // Rehydrate to Event instances so the template's getTimeText() works.
    this.tvScreenSrv.payload$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((payload) => {
      this.events = this.convSrv
        .convert2TypedArray<Event>(payload?.events ?? [], Event)
        .slice(0, this.maxCount);
    });
  }
}
